import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import userService from "../../Services/UserService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import Loader from "../../Constant/Loader";
import InfoModel from "./InfoModel";
import teamService from "../../Services/TeamService";
import CustomHeading from "../../common/CustomHeading";

const UserUpdate = () => {
  const { userId } = useParams();

  const { state } = useLocation();
  const { user } = state || {};
  const teamId = user?.teamName?.[0]?.id || null;
  const [name, setName] = useState(user?.name || "");
  const [emailId, setEmailId] = useState(user?.emailId || "");
  const [employeeId, setEmployeeId] = useState(user?.employeeId || "");
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || "");
  const [infoShow, setInfoShow] = useState(false);
  const [role, setRole] = useState(user?.role.toUpperCase() || "");
  const [status, setStatus] = useState(user?.status || false);
  const [errors, setErrors] = useState({});
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dealCount, setDealCount] = useState(0);
  const [leadCount, setLeadCount] = useState(0);




  const navigate = useNavigate();
  const userObj = JSON.parse(localStorage.getItem("userData"));
    const [users, SetUsers] = useState([]);
  const userRole = userObj?.user?.role;
  useEffect(() => {
    if (phoneNumber.length === 10 && !phoneNumberError) {
      checkDuplicatePhoneNumber();
    }
  }, [phoneNumber]);

  

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!employeeId) newErrors.employeeId = "Employee ID is required";
    if (!phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (phoneNumberError) {
      newErrors.phoneNumber = "Invalid phone number format or already exists";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const checkDuplicatePhoneNumber = async () => {
    try {
      const phoneIntNumber = parseInt(phoneNumber);
      const phoneResponse = await userService.validatePhoneNumber(
        phoneIntNumber
      );
      if (phoneResponse.data.duplicate) {
        setPhoneNumberError(true);
        showErrorToast("Phone number already exists");
      } else {
        setPhoneNumberError(false);
      }
    } catch (error) {
      showErrorToast(error.response.data);

      console.error("Error checking phone number:", error);
    }
  };
  const handlePhoneNumberChange = (e) => {
    const newPhoneNumber = e.target.value.replace(/\D/g, "");
    setPhoneNumber(newPhoneNumber.slice(0, 10));
    setPhoneNumberError(
      newPhoneNumber.length !== 10 || /\D/.test(newPhoneNumber)
    );
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    const updatedUserData = {
      uid: userId,
      name,
      employeeId,
      phoneNumber: parseInt(phoneNumber),
      status: status === "Active",
    };
    setLoading(true);
    try {
      const response = await userService.updateUser(userId, updatedUserData);

      if (response.data) {
        if (userRole === "Admin") {
          navigate("/admin/users", {
            state: { message: "User updated successfully" },
          });
        } else if (userRole === "CMO") {
          navigate("/cmo/users", {
            state: { message: "User updated successfully" },
          });
        }
      }
    } catch (error) {
      showErrorToast(error.response.data);
    } finally {
      setLoading(false); // Enable button after submit
    }
  };

  const handleBack = () => {
    if (userRole === "Admin") {
      navigate("/admin/users");
    } else if (userRole === "CMO") {
      navigate("/cmo/users");
    }
  };

  const handleToggleClick = async () => {
    try {
      const body = {
        uid: userId,
      };
      const response = await userService.checkUserDeactivation(body);
      setInfoShow(true);
      setStatus(!status);
      const data = response?.data;
      console.log(response);
      if (response.status === 200) {
        console.log(data);
        showSuccessToast(response?.data);
        setDealCount(data.dealCount);
        setLeadCount(data?.leadCount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeactiveUser = async () => {
    try {
      const body = {
        uid: userId,
        dealCount: dealCount,
        leadCount: leadCount,
        status: status,
      };
      const response = await userService.userDeactivation(body);

      console.log(response);
      if (response.status === 200) {
        showSuccessToast(response?.data);

        setInfoShow(false);
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReassignLead = () => {



    const path = userRole === "Admin" ? "/admin" : "/cmo";

    navigate(`${path}/lead-reasign-lead`, {
      state: {
        userId: userId,
        teamId: teamId,
        filterOpen: true,
      },
    });
  };

  useEffect(()=>{
const userData = async () => {
  try{
    const userResponse = await teamService.getUserName();
          SetUsers(userResponse.data.users); 
  }catch(error){
    console.log("Error");
  }
}
userData();
  },[])

  const handleDealReassign = async ()=>{

    
    const path = userRole === "Admin" ? "/admin" : "/cmo";
    navigate(`${path}/pipline-user-deal`, {
      state: {
        userId: userId,
        userList : users,
      }
      });
  }
  return (
    <div className="bg-appGrayBackground h-screen">
      {loading ? <Loader /> : ""}
      <AdminAppBar />
      <ToastContainer />
      <div className="bg-appGrayBackground mt-20 pt-4 px-6">
        <div className=" flex  justify-between ">
        <CustomHeading title={`Update User`} isIcon={true}/> 

          <div className="">
            <button
              onClick={handleUpdate}
              className="bg-customGreen text-white md:w-28 md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl lg:text-2xl font-medium"
              disabled={loading} // Disable button while loading
            >
              Update
            </button>
          </div>
        </div>

        <form className="bg-white shadow-md 3xl:w-12/12 3xl:ml-12 rounded md:px-4 lg:px-8 md:pt-6 lg:pt-7 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="name"
            >
              User Name <span className="text-red-600">*</span>
            </label>
            <input
              className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name && "border-red-500"
              }`}
              id="name"
              type="text"
              placeholder={errors.name || "Enter User Name"}
              required
              maxLength={40}
              value={name}
              // onChange={(e) => setName(e.target.value)}
              onChange={(e) => {
                setName(
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                );
                setErrors((prevErrors) => ({ ...prevErrors, name: "" }));
              }}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="phoneNumber"
            >
              Phone Number<span className="text-red-600">*</span>
            </label>
            <input
              className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.phoneNumber || (phoneNumberError && "border-red-500")
              }`}
              id="phoneNumber"
              type="text"
              placeholder={errors.phoneNumber || "Enter Phone Number"}
              required
              value={phoneNumber}
              // onChange={(e) => setPhoneNumber(e.target.value)}
              onChange={handlePhoneNumberChange}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="role"
            >
              Email Id<span className="text-red-600">*</span>
            </label>
            <input
              className={`shadow appearance-none bg-gray-100 cursor-default border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}
              id="emailId"
              type="text"
              readOnly
              value={emailId}
            />
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="employeeId"
            >
              Employee ID
            </label>
            <input
              className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.employeeId && "border-red-500"
              }`}
              id="employeeId"
              type="text"
              placeholder={errors.employeeId || "Enter Employee ID"}
              required
              maxLength={30}
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
            />
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="role"
            >
              Role<span className="text-red-600">*</span>
            </label>
            <input
              className={`shadow appearance-none bg-gray-100 cursor-default border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}
              id="role"
              type="text"
              readOnly
              value={role}
            />
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="status"
            >
              Status
            </label>
            {user.status ? (
              <div className="flex items-center gap-5">
                <span className={status ? "" : "text-red-600"}>
                  {"Disable"}
                </span>
                <label className="inline-flex items-center cursor-pointer">
                  <div className="relative">
                    <input
                      type="checkbox"
                      className="sr-only"
                      checked={status}
                      onClick={handleToggleClick}
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full"></div>
                    <div
                      className={`absolute left-1 top-1  w-4 h-4 rounded-full transition-transform ${
                        status
                          ? "translate-x-5 bg-green-500"
                          : " bg-red-500 translate-x-0"
                      }`}
                    ></div>
                  </div>
                </label>
                <span className={status ? "text-green-600" : "text-black"}>
                  {"Active"}
                </span>
              </div>
            ) : (
              <div>
                <span className="text-red-600">User is not active</span>
              </div>
            )}
          </div>
        </form>
      </div>
      <InfoModel
        show={infoShow}
        leadCount={leadCount}
        dealCount={dealCount}
        reassignHandle={handleReassignLead}
        dealReassignHandle={handleDealReassign}
        userDeactiveHandle={handleDeactiveUser}
        title={`${
          leadCount == 0 || dealCount === 0
            ? "Are You Sure"
            : "User Has Active Clients"
        } `}
        message={
          leadCount > 0 ? (
            <>
              This user is currently managing{" "}
              <span className="text-orange-500">
                {leadCount} Clients in leads
              </span>
              . So, Manually Reassign the Responsible person before disabling{" "}
              <span className="text-blue-500">{user?.name}</span>.
            </>
          ) : dealCount > 0 ? (
            <>
              This user is currently managing{" "}
              <span className="text-orange-500">
                {dealCount} Clients in Deal
              </span>
              . So, Manually Reassign the Responsible person before disabling{" "}
              <span className="text-blue-500 truncate whitespace-pre-wrap">
                {user?.name}
              </span>
              .
            </>
          ) : (
            <>
              “Are you sure you want to disable this user? They will be logged
              out and lose access to the system immediately.”
            </>
          )
        }
        close={() => {
          setInfoShow(false);
          setStatus(user?.status);
        }}
      />
    </div>
  );
};

export default UserUpdate;
